import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import { Icon } from 'components/atoms';

import {
  MessageContainer,
  Message,
  MessageIcon,
  MessageText,
  CloseIcon
} from './toasts-style';

const Toast = ({ type, message, id, duration, toasts }) => {
  const handleTheme = t => {
    switch (t) {
      case 'success':
        return { color: 'var(--color-success)', icon: 'checkCircledFilled' };
      case 'warning':
        return {
          color: 'var(--color-warning)',
          icon: 'exclamationTriangleFilled'
        };
      case 'error':
        return {
          color: 'var(--color-error)',
          icon: 'exclamationTriangleFilled'
        };
      case 'info':
      default:
        return { color: 'var(--color-primary)', icon: 'infoCircledFilled' };
    }
  };

  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    let timer;
    if (duration) {
      timer = setTimeout(() => setIsLeaving(true), duration);
    }
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <MessageContainer
      className={isLeaving && 'is-leaving'}
      onAnimationEnd={() => {
        if (isLeaving) {
          toasts.removeToast(id);
        }
      }}
    >
      <Message>
        <MessageIcon style={{ color: handleTheme(type).color }}>
          <Icon name={handleTheme(type).icon} size='var(--font-size-2xl)' />
        </MessageIcon>
        <MessageText>
          <ReactMarkdown source={message} escapeHtml={false} />
        </MessageText>
        <CloseIcon
          onClick={() => {
            setIsLeaving(true);
          }}
        >
          <Icon name='cross2' size='var(--font-size-xl)' />
        </CloseIcon>
      </Message>
    </MessageContainer>
  );
};

export default Toast;
